import React from 'react';
import { IBlockData } from '@core/typings';
import { BasicType } from '@core/constants';
import { createBlock } from '@core/utils/createBlock';
import { merge } from 'lodash';
import { t } from '@core/utils';
import { BasicBlock } from '@core/components/BasicBlock';

export type IRaw = IBlockData<
	{
		'background-color'?: string;
		padding?: string;
	},
	{ content: string }
>;

export const Raw = createBlock<IRaw>({
	get name() {
		return t('HTML');
	},
	type: BasicType.RAW,
	create: payload => {
		const defaultData: IRaw = {
			type: BasicType.RAW,
			data: {
				value: {
					content: `<p style="font-family: Arial, sans-serif; color: var(--color-blackish); margin: 0px; font-size: 14px;">
This is an HTML block,
</p>
<p style="font-family: Arial, sans-serif; color: var(--color-blackish); margin: 10px 0px 0px; font-size: 14px;">
Click "<strong>Edit HTML</strong>" in the right panel to paste your custom code.
</p>`,
				},
			},
			attributes: {
				padding: '20px 20px 20px 20px',
				'background-color': '#FFFFFF',
			},
			children: [],
		};
		return merge(defaultData, payload);
	},
	validParentType: [
		BasicType.PAGE,
		BasicType.WRAPPER,
		BasicType.SECTION,
		BasicType.GROUP,
		BasicType.COLUMN,
		BasicType.HERO,
	],
	render(params) {
		const { data } = params;
		const content = data.data.value.content;
		const padding = data.attributes.padding || '0px';
		const backgroundColor = data.attributes['background-color'] || 'transparent';
		const wrappedContent = `<div style="padding:${padding};background-color:${backgroundColor};">${content}</div>`;

		// Full-width mode - render directly without wrapper constraints
		// This allows the HTML to span the full email width
		return (
			<BasicBlock
				params={params}
				tag='mj-raw'
			>
				{wrappedContent}
			</BasicBlock>
		);
	},
});
